import {Divider, Grid, IconButton, Typography, Box} from "@mui/material";
import { InputField } from "../../../../utils/FormFields";
import React, {useState} from "react";
import {Visibility, VisibilityOff} from "@mui/icons-material";

export default function EditEmployeePassword(props: any) {
    const [passwordVisibility, setPasswordVisibility] = useState({ oldPwd: false, newPwd: false, newPwdConfirm: false });

    const handleClickShowOldPassword = () => {
        setPasswordVisibility({ ...passwordVisibility, oldPwd: !passwordVisibility?.oldPwd });
    };
    const handleClickShowNewPassword = () => {
        setPasswordVisibility({ ...passwordVisibility, newPwd: !passwordVisibility?.newPwd });
    };
    const handleClickShowNewPasswordConfirm = () => {
        setPasswordVisibility({ ...passwordVisibility, newPwdConfirm: !passwordVisibility?.newPwdConfirm });
    };
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    return (
        <>
            <Typography variant="h5" gutterBottom sx={{ p: 0 }}>
                Change Password
            </Typography>
            <Divider />
            <Grid container rowSpacing={3} spacing={2} sx={{ pt: 8, justifyContent: "center", alignContent: "center" }}>
                <Grid xs={12} sm={4}>
                    <Box sx={{ pl: 1, pt: 2 }}>
                        <InputField
                            name="OldPassword"
                            label="Old Password"
                            type= {passwordVisibility.oldPwd ? "text":"password"}
                            fullWidth
                            suffix={
                                <IconButton onClick={handleClickShowOldPassword} onMouseDown={handleMouseDownPassword} edge="end">
                                    {passwordVisibility.oldPwd ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            }
                        />
                    </Box>    
                </Grid>
                <Grid container />

                <Grid xs={12} sm={4}>
                    <Box sx={{ pl: 1, pt: 2 }}>
                        <InputField
                            name="NewPassword"
                            label="New Password"
                            type= {passwordVisibility.newPwd ? "text":"password"}
                            fullWidth
                            suffix={
                                <IconButton onClick={handleClickShowNewPassword} onMouseDown={handleMouseDownPassword} edge="end">
                                    {passwordVisibility.newPwd ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            }
                        />
                    </Box>    
                </Grid>
                <Grid container />
                <Grid xs={12} sm={4}>
                    <Box sx={{ pl: 1, pt: 2 }}>            
                        <InputField
                            name="NewPasswordConfirmed"
                            label="Confirm New Password"
                            type= {passwordVisibility.newPwdConfirm ? "text":"password"}
                            fullWidth
                            suffix={
                                <IconButton onClick={handleClickShowNewPasswordConfirm} onMouseDown={handleMouseDownPassword} edge="end">
                                    {passwordVisibility.newPwdConfirm ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            }
                        />
                    </Box>    
                </Grid>
            </Grid>
        </>
    );
}
